import React, { useEffect, useState,Fragment } from "react";
import creteImage from "../assets/images/crete.png";
import { useNavigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../assets/css/style.css";
import "../assets/css/bootstrap-datepicker.css";

import api, { IMAGE_BASE_URL } from "../api/Api.js";
import { useLanguage } from "../context/LanguageContext";
import CarDetailsModal from "../components/CarDetailsModal";

function HomePage() {

  const withBreaks = (text) => {
    let str = String(text || "");
  
    // If the backend has no break marker, split the text roughly in the middle
    if (!/<br\s*\/?>|\\n|\n/i.test(str)) {
      const words = str.trim().split(/\s+/);
      const mid = Math.floor(words.length / 2);
      str = words.slice(0, mid).join(" ") + "\n" + words.slice(mid).join(" ");
    }
  
    return str.split(/<br\s*\/?>|\\n|\n/i).map((line, i, arr) => (
      <Fragment key={i}>
        {line.trim()}
        {i < arr.length - 1 && <br />}
      </Fragment>
    ));
  };

  // =====================================================
  // LANGUAGE
  // =====================================================

  const { translations, language ,t } = useLanguage();

  const tr = (group, number, fallback = "") =>
  translations?.[group]?.[`${group}${number}`] || fallback;
  const [banner, setBanner] = useState(null); // banner
  const navigate = useNavigate();

  const bookingengine = translations?.bookingengine || {};

  // =====================================================
  // BACKEND
  // =====================================================

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // =====================================================
  // HOME CONTENT
  // =====================================================

  const [homeContent, setHomeContent] = useState({
    cont_title: "",
    cont_details: "",
  });

  const [whyChooseContents, setWhyChooseContents] = useState({
    page9: {
      cont_title: "",
      cont_details: "",
    },

    page10: {
      cont_title: "",
      cont_details: "",
    },

    page11: {
      cont_title: "",
      cont_details: "",
    },
  });

  const [loadingHomeContent, setLoadingHomeContent] = useState(true);

  const [loadingWhyChoose, setLoadingWhyChoose] = useState(true);

  // =====================================================
  // CAR DETAILS MODAL STATES
  // =====================================================

  const [selectedCarForDetails, setSelectedCarForDetails] = useState(null);

  const [showCarDetailsModal, setShowCarDetailsModal] = useState(false);

  // =====================================================
  // REMOVE EMPTY LIST ITEMS FROM DATABASE HTML
  // =====================================================

  const cleanContentHtml = (html) => {
    if (!html) {
      return "";
    }

    return String(html)
      .replace(/<li>\s*<\/li>/gi, "")
      .replace(/<li>(?:\s|&nbsp;|<br\s*\/?>)*<\/li>/gi, "")
      .replace(/<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "")
      .replace(/<div>(?:\s|&nbsp;|<br\s*\/?>)*<\/div>/gi, "");
  };

  // =====================================================
  // BOOKING FORM STATES
  // =====================================================

  const [pickupLocation, setPickupLocation] = useState("");

  const [returnLocation, setReturnLocation] = useState("");

  const [pickupDate, setPickupDate] = useState("");

  const [pickupHour, setPickupHour] = useState("10");

  const [pickupMinute, setPickupMinute] = useState("00");

  const [returnDate, setReturnDate] = useState("");

  const [returnHour, setReturnHour] = useState("10");

  const [returnMinute, setReturnMinute] = useState("00");

  const [carType, setCarType] = useState("");

  const [driverAge, setDriverAge] = useState("0");

  const [clientId, setClientId] = useState("");

  const [clientEmail, setClientEmail] = useState("");

  const [bookingLoading, setBookingLoading] = useState(false);

  // =====================================================
  // LOCATION STATES
  // =====================================================

  const [locations, setLocations] = useState([]);

  const [loadingLocations, setLoadingLocations] = useState(false);

  // =====================================================
  // CAR STATES
  // =====================================================

  const [cars, setCars] = useState([]);

  const [loadingCars, setLoadingCars] = useState(true);
  const [showRegularClientLogin, setShowRegularClientLogin] = useState(false); // code-1416

  // =====================================================
  // CAR CAROUSEL
  // =====================================================
  const [carouselIndex, setCarouselIndex] = useState(0);

  const [CARDS_VISIBLE, setCardsVisible] = useState(
    window.innerWidth <= 767 ? 1 : 4
  );

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 767) {
        setCardsVisible(1); // Mobile
      } else if (window.innerWidth <= 991) {
        setCardsVisible(2); // Tablet
      } else {
        setCardsVisible(4); // Desktop
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // =====================================================
  // HOURS
  // =====================================================

  const hours = [];

  for (let i = 0; i <= 23; i++) {
    hours.push(String(i).padStart(2, "0"));
  }

  // =====================================================
  // MINUTES
  // =====================================================

  const minutes = ["00", "15", "30", "45"];

  // =====================================================
  // GET LANGUAGE ID
  // =====================================================

  const getLanguageId = () => {
    if (typeof language === "number" || !isNaN(Number(language))) {
      return Number(language);
    }

    if (language && typeof language === "object") {
      return (
        Number(language.lang_id || language.language_id || language.id) || 1
      );
    }

    return 1;
  };

  const languageId = getLanguageId();

  // ============================================================
  // TODAY
  // ============================================================

  const getToday = () => {
    const date = new Date();

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const today = getToday();



  const handlePickupChange = (e) => {
    const selectedDate = e.target.value;
  
    setPickupDate(selectedDate);
  
    if (selectedDate) {
      const date = new Date(selectedDate);
      date.setDate(date.getDate() + 3);
  
      const formattedDate = date.toISOString().split("T")[0];
      setReturnDate(formattedDate);
    } else {
      setReturnDate("");
    }
  };
  //------------------
  // Banner
  //---------------
  useEffect(() => {
    let cancelled = false;

    const loadBanner = async () => {
      try {
        const response = await api.get("/banners/getBanner", {
          params: { lang_id: languageId, banner_for: 1 },
        });

        const result = response.data;
        console.log("BANNER RESULT:", result);

        if (!cancelled) {
          setBanner(result && result.success ? result.data : null);
        }
      } catch (error) {
        console.error("BANNER ERROR:", error);

        if (!cancelled) {
          setBanner(null);
        }
      }
    };

    loadBanner();

    return () => {
      cancelled = true;
    };
  }, [languageId]);


  const bannerImage = banner?.banner_image
  ? `${IMAGE_BASE_URL}/${String(banner.banner_image).replace(/^\/+/, "")}`
  : `http://192.168.0.6:3000/static/media/bg_1.e5ee7e7182b42d457ccc.jpg`;

  // =====================================================
  // FETCH SINGLE CONTENT PAGE
  // =====================================================

  const fetchContentPage = async (pageId, langId) => {
    try {
      const response = await api.get("/contents/content", {
        params: {
          page_id: pageId,
          lang_id: langId,
        },
      });

      const result = response.data;

      if (result && result.success && result.data) {
        if (Array.isArray(result.data)) {
          return result.data[0] || null;
        }

        return result.data;
      }

      return null;
    } catch (error) {
      console.error(`ERROR FETCHING PAGE ${pageId}:`, error);

      return null;
    }
  };

  // =====================================================
  // FETCH HOME PAGE - PAGE 12
  // =====================================================

  useEffect(() => {
    let cancelled = false;

    const loadHomeContent = async () => {
      setLoadingHomeContent(true);

      const content = await fetchContentPage(12, languageId);

      if (cancelled) {
        return;
      }

      if (content) {
        setHomeContent({
          cont_title: content.cont_title || "",

          cont_details: content.cont_details || "",
        });
      } else {
        setHomeContent({
          cont_title: "",
          cont_details: "",
        });
      }

      setLoadingHomeContent(false);
    };

    loadHomeContent();

    return () => {
      cancelled = true;
    };
  }, [languageId]);

  // =====================================================
  // FETCH PAGE 9, 10, 11
  // =====================================================

  useEffect(() => {
    let cancelled = false;

    const loadWhyChooseContent = async () => {
      setLoadingWhyChoose(true);

      const [page9, page10, page11] = await Promise.all([
        fetchContentPage(9, languageId),

        fetchContentPage(10, languageId),

        fetchContentPage(11, languageId),
      ]);

      if (cancelled) {
        return;
      }

      setWhyChooseContents({
        page9: {
          cont_title: page9?.cont_title || "",

          cont_details: page9?.cont_details || "",
        },

        page10: {
          cont_title: page10?.cont_title || "",

          cont_details: page10?.cont_details || "",
        },

        page11: {
          cont_title: page11?.cont_title || "",

          cont_details: page11?.cont_details || "",
        },
      });

      setLoadingWhyChoose(false);
    };

    loadWhyChooseContent();

    return () => {
      cancelled = true;
    };
  }, [languageId]);

  // =====================================================
  // FETCH LOCATIONS
  // =====================================================

  useEffect(() => {
    fetchLocations();
  }, [languageId]);

  const fetchLocations = async () => {
    try {
      setLoadingLocations(true);

      const response = await api.get("/locations/getLocations", {
        params: {
          city_id: 1,
          lang_id: languageId,
        },
      });

      const result = response.data;

      if (result.success && Array.isArray(result.data)) {
        setLocations(result.data);
      } else {
        setLocations([]);
      }
    } catch (error) {
      console.error("========== LOCATION ERROR ==========");

      console.error("MESSAGE:", error.message);

      console.error("CODE:", error.code);

      console.error("RESPONSE:", error.response);

      console.error("REQUEST:", error.request);

      setLocations([]);
    } finally {
      setLoadingLocations(false);
    }
  };

  // =====================================================
  // FETCH CARS
  // =====================================================

  useEffect(() => {
    fetchCars();
  }, [languageId]);

  const fetchCars = async () => {
    try {
      setLoadingCars(true);

      const response = await api.get("/cars/getCars", {
        params: {
          lang_id: languageId,
        },
      });

      const result = response.data;
      if (result.success) {
        setCars(Array.isArray(result.data) ? result.data : []);
      } else {
        setCars([]);
      }
    } catch (error) {
      console.error("Error loading cars:", error);

      setCars([]);
    } finally {
      setLoadingCars(false);
    }
  };

  // =====================================================
  // RESET CAROUSEL
  // =====================================================

  useEffect(() => {
    setCarouselIndex(0);
  }, [languageId, cars.length]);

  // =====================================================
  // AUTO CAROUSEL
  // =====================================================

  useEffect(() => {
    if (cars.length <= CARDS_VISIBLE) {
      return;
    }

    const slideInterval = setInterval(() => {
      setCarouselIndex((prevIndex) => {
        const nextIndex = prevIndex + 1;

        if (nextIndex > cars.length - CARDS_VISIBLE) {
          return 0;
        }

        return nextIndex;
      });
    }, 3000);

    return () => clearInterval(slideInterval);
  }, [cars.length]);

  // =====================================================
  // CAR IMAGE
  // =====================================================

  const getCarImage = (image) => {
    if (!image) {
      return "";
    }

    let imagePath = String(image).trim();

    if (!imagePath) {
      return "";
    }

    if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
      return imagePath;
    }

    imagePath = imagePath.replace(/^\/+/, "");

    if (imagePath.startsWith("uploads/")) {
      return `${IMAGE_BASE_URL}/${imagePath}`;
    }

    if (imagePath.startsWith("cars/")) {
      return `${IMAGE_BASE_URL}/${imagePath}`;
    }

    if (imagePath.startsWith("images/")) {
      return `${IMAGE_BASE_URL}/${imagePath}`;
    }

    if (imagePath.startsWith("CarImage/")) {
      return `${IMAGE_BASE_URL}/${imagePath}`;
    }

    return `${IMAGE_BASE_URL}/images/CarImage/${imagePath}`;
  };

  // =====================================================
  // IMAGE ERROR
  // =====================================================

  const handleImageError = (e, imageUrl) => {
    console.error("CAR IMAGE FAILED:", imageUrl);

    e.currentTarget.style.display = "none";

    const parent = e.currentTarget.parentElement;

    if (parent) {
      const fallback = parent.querySelector(".image-fallback");

      if (fallback) {
        fallback.style.display = "flex";
      }
    }
  };

  // =====================================================
  // BOOK NOW
  // =====================================================

  const handleBookNow = (car) => {
    try {
      const selectedCarId = car.carmodel_id || car.car_id || car.id;

      const existingCriteria = sessionStorage.getItem("bookingCriteria");

      if (existingCriteria) {
        try {
          const criteria = JSON.parse(existingCriteria);

          criteria.selectedCarId = selectedCarId;

          criteria.selectedCar = car;

          sessionStorage.setItem("bookingCriteria", JSON.stringify(criteria));
        } catch (error) {
          console.error("Unable to update booking criteria:", error);
        }
      }

      sessionStorage.setItem("selectedCar", JSON.stringify(car));

      // Close modal if opened
      setShowCarDetailsModal(false);

      setSelectedCarForDetails(null);

      navigate("/cardetails");
    } catch (error) {
      console.error("BOOK NOW ERROR:", error);
    }
  };

  // =====================================================
  // DETAILS BUTTON
  // =====================================================

  const handleDetails = (car) => {
    console.log("DETAILS CAR:", car);
    console.log("========== FULL CAR DATA ==========");
    console.log(JSON.stringify(car, null, 2));
    console.log("===================================");
    setSelectedCarForDetails(car);

    setShowCarDetailsModal(true);
  };

  // =====================================================
  // CLOSE DETAILS MODAL
  // =====================================================

  const closeCarDetailsModal = () => {
    setShowCarDetailsModal(false);

    setSelectedCarForDetails(null);
  };

  // =====================================================
  // CLOSE MODAL WITH ESCAPE
  // =====================================================

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        closeCarDetailsModal();
      }
    };

    if (showCarDetailsModal) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [showCarDetailsModal]);

  // =====================================================
  // BOOKING SUBMIT
  // =====================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!pickupLocation) {
      alert("Please select pickup location");
      return;
    }

    if (!pickupDate) {
      alert("Please select pickup date");
      return;
    }

    if (!returnLocation) {
      alert("Please select return location");
      return;
    }

    if (!returnDate) {
      alert("Please select return date");
      return;
    }

    if (
      pickupDate &&
      returnDate &&
      new Date(returnDate) < new Date(pickupDate)
    ) {
      alert("Return date cannot be before pickup date");
      return;
    }

    try {
      setBookingLoading(true);

      const bookingCriteria = {
        cmbPickLocation: pickupLocation,

        pickdate: pickupDate,

        cmbpickHour: pickupHour,

        cmbpickmin: pickupMinute,

        cmbDropLocation: returnLocation,

        returndate: returnDate,

        cmbreturnHour: returnHour,

        cmbreturnmin: returnMinute,

        cmbcartype: carType,

        cmbdrvage: driverAge,

        clientid: clientId,

        clientemail: clientEmail,

        selectedlanguage: languageId,

        Editourcar: "",
      };

      console.log("BOOKING CRITERIA:", bookingCriteria);

      sessionStorage.setItem(
        "bookingCriteria",
        JSON.stringify(bookingCriteria)
      );

      navigate("/bookacar");
    } catch (error) {
      console.error("BOOKING SUBMIT ERROR:", error);
    } finally {
      setBookingLoading(false);
    }
  };

  // =====================================================
  // RETURN
  // =====================================================

  return (
    <div className="home-page">
      {/* =====================================================
          HERO / BOOKING AREA
      ====================================================== */}

      <div className="container-fluid p-0">
        <div className="">
          {/* LEFT PROMOTION */}

          <div
            className="
              col-xs-12
              col-sm-12
              col-md-4
              col-lg-4
              left-box
            "
            style={{
          
            }}
          >
            <h2>
              {t("othersnewstatics.othersnewstatic60", "Explore Crete")}
              <br />
              <span
                style={{
                  color: "#ffe300",
                  fontSize: "50px",
                  fontFamily: "brusherregular",
                }}
              >
                 {t("othersnewstatics.othersnewstatic61", "Your Way")}
              
              </span>
            </h2>

            <p className="subline">
              {withBreaks(
                t(
                  "othersnewstatics.othersnewstatic62",
                  "Reliable cars, unbeatable prices and freedom to explore every corner."
                )
              )}
              {/* Reliable cars, unbeatable prices and
              <br />
              freedom to explore every corner. */}
            </p>

            <ul
              style={{
                color: "#fff",
				        paddingLeft: "40px",
              }}
            >
              <li>
              {withBreaks(
                t(
                  "othersnewstatics.othersnewstatic63",
                  "Best Price Guarantee No hidden fees"
                )
                )}
                {/* Best Price Guarantee
                <br />
                No hidden fees */}
              </li>

              <li>
             <p>
                  {withBreaks(
                      t(
                        "othersnewstatics.othersnewstatic64",
                        "Unlimited Kilometers Drive without limits"
                      )
                  )}
              </p>
                {/* Unlimited Kilometers
                <br />
                Drive without limits */}
              </li>

              <li>
                {withBreaks(
                  t(
                    "othersnewstatics.othersnewstatic65",
                    "24/7 Customer Support We are here for you"
                  )
                )}
                {/* 24/7 Customer Support
                <br />
                We are here for you */}
              </li>
            </ul>

            <div className="p-box">
              <div
                className="
                  col-xs-12
                  col-sm-12
                  col-md-8
                  col-lg-8
                "
                style={{
                  float: "left",
                  padding: 0,
                }}
              >
                <p className="offerline">  {
                t(
                  "othersnewstatics.othersnewstatic66",
                  "SPECIAL OFFER"
                )
              }</p>

                <p className="p-line">
                  <span className="span">-15%</span>
                  
                  <span className="online">{
                t(
                  "othersnewstatics.othersnewstatic67",
                  "For online bookings"
                )
              }</span>
                </p>
              </div>

              <div
                className="
                  col-xs-12
                  col-sm-12
                  col-md-4
                  col-lg-4
                "
                style={{
                  float: "left",
                  padding: 0,
                }}
              >
                <a href="#booking-form" className="butline">
                {
                    t(
                      "othersnewstatics.othersnewstatic59",
                      "Book Now"
                    )
                  }
                </a>
              </div>

              <div className="clearfix"></div>
            </div>
          </div>

          {/* RIGHT HERO */}

          <div
            className="
              col-xs-12
              col-sm-12
              col-md-8
              col-lg-8
            "
            style={{
              float: "left",
              padding: 0,
            }}
          >
            <div
              className="
                hero-wrap
                ftco-degree-bg
              "
              style={{ backgroundImage: `url(${bannerImage})` }}
              >
              <div className="container">
                <div
                  className="
                    row
                    no-gutters
                    slider-text
                    justify-content-start
                    align-items-center
                    justify-content-center
                  "
                >
                  <div className="col-lg-10">
                    <div
                      className="
                        text
                        w-100
                        text-center
                        mb-md-5
                        pb-md-5
                      "
                    >
                      <h1 className="mb-12">
                      {t("othersnewstatics.othersnewstatic0", "Fast & Easy Way To Rent A Car")}
                      </h1>

                      {/* BOOKING FORM */}

                      <div
                        className="
                          col-md-12
                          d-flex
                          align-items-center
                        "
                        id="booking-form"
                      >
                        <form
                          onSubmit={handleSubmit}
                          className="
                            request-form
                            bg-primary
                          "
                        >
                          {/* PICKUP */}

                          <div
                            className="col-md-6"
                            style={{
                              float: "left",
                              padding: 0,
                            }}
                          >
                            <div
                              className="col-lg-12"
                              style={{
                                float: "left",
                                padding: 0,
                                textAlign: "left",
                              }}
                            >
                              <label className="label">
                                {bookingengine.bookingengine0 ||
                                  "Pick-up Location"}
                              </label>
                            </div>

                            <div
                              className="col-lg-12"
                              style={{
                                float: "left",
                                padding: 0,
                              }}
                            >
                              <div className="clearfix"></div>
                             
                              <div
                                className="
                                  col-lg-12
                                  form-group
                                  mr-2
                                "
                                style={{
                                  float: "left",
                                  padding: "0px 9px 0px 0px",
                                }}
                              >
                                <div className="selectParent">
                                  <select
                                    className="arrow
                                      form-control
                                      selectParent
                                      select
                                    "
                                    name="cmbPickLocation"
                                    value={pickupLocation}
                                    onChange={(e) =>
                                      setPickupLocation(e.target.value)
                                    }
                                  >
                                    <option value="">
                                      {loadingLocations
                                        ? "Loading locations..."
                                        : bookingengine.bookingengine8 ||
                                          "Select location"}
                                    </option>

                                    {locations.map((location) => (
                                      <option
                                        key={location.loc_id}
                                        value={location.loc_id}
                                      >
                                        {location.loc_name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                            
                            <div
                              className="col-lg-12"
                              style={{
                                float: "left",
                                padding: 0,
                              }}
                            >
                           
                              <label className="label" style={{marginRight: "52px",float: "left"}}>
                                    {bookingengine.bookingengine1 ||
                                      "Pick-up Date & Time"}
                                      {/* Pick-up Date & Time */}
                                  </label>
                              <div
                                className="
                                  col-lg-6
                                  form-group
                                  mr-2
                                "
                                style={{
                                  float: "left",
                                  padding: "0px 9px 0px 0px",
                                }}
                              >
                                <input
                                  type="date"
                                  name="pickdate"
                                  className="form-control "
                                  min={today}
                                  value={pickupDate}
                                  onChange={handlePickupChange}
                                />
                           
                              </div>

                              <div
                                className="
                                  col-lg-6
                                  form-group
                                "
                                style={{
                                  float: "left",
                                  padding: "0px 9px 0px 0px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "3px",
                                  }}
                                >
                                  <select
                                    name="cmbpickHour"
                                    className="
                                      arrow
                                      form-control
                                    "
                                    value={pickupHour}
                                    onChange={(e) =>
                                      setPickupHour(e.target.value)
                                    }
                                    style={{
                                      width: "50%",
                                    }}
                                  >
                                    {hours.map((hour) => (
                                      <option key={hour} value={hour}>
                                        {hour}
                                      </option>
                                    ))}
                                  </select>

                                  <select
                                    name="cmbpickmin"
                                    className="
                                      arrow
                                      form-control
                                    "
                                    value={pickupMinute}
                                    onChange={(e) =>
                                      setPickupMinute(e.target.value)
                                    }
                                    style={{
                                      width: "50%",
                                    }}
                                  >
                                    {minutes.map((minute) => (
                                      <option key={minute} value={minute}>
                                        {minute}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* RETURN */}

                          <div
                            className="col-md-6"
                            style={{
                              float: "left",
                              padding: 0,
                            }}
                          >
                            <div
                              className="col-lg-12"
                              style={{
                                float: "left",
                                padding: 0,
                                textAlign: "left",
                              }}
                            >
                              <label className="label">
                                {bookingengine.bookingengine3 ||
                                  "Drop-off Location"}
                              </label>
                            </div>

                            <div
                              className="col-lg-12"
                              style={{
                                float: "left",
                                padding: 0,
                              }}
                            >
                              <div
                                className="
                                  col-lg-12
                                  form-group
                                  mr-2
                                "
                                style={{
                                  float: "left",
                                  padding: "0px 9px 0px 0px",
                                }}
                              >
                                <div className="selectParent">
                                  <select
                                    className="arrow
                                      form-control
                                      selectParent
                                      select
                                    "
                                    name="cmbDropLocation"
                                    value={returnLocation}
                                    onChange={(e) =>
                                      setReturnLocation(e.target.value)
                                    }
                                  >
                                    <option value="">
                                      {loadingLocations
                                        ? "Loading locations..."
                                        : bookingengine.bookingengine8 ||
                                          "Select location"}
                                    </option>

                                    {locations.map((location) => (
                                      <option
                                        key={location.loc_id}
                                        value={location.loc_id}
                                      >
                                        {location.loc_name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div
                              className="col-lg-12"
                              style={{
                                float: "left",
                                padding: 0,
                              }}
                            >
                              <label className="label" style={{marginRight: "52px",float: "left"}}>
                                {bookingengine.bookingengine4 ||
                                  "Drop-off Date & Time"}
                              </label>
                              <div
                                className="
                                  col-lg-6
                                  form-group
                                  ml-2
                                "
                                style={{
                                  float: "left",
                                  padding: "0px 9px 0px 0px",
                                }}
                              >
                                <input
                                  type="date"
                                  name="returndate"
                                  className="form-control"
                                  min={ pickupDate || today }
                                  value={returnDate}
                                  onChange={(e) => setReturnDate(e.target.value)}
                                />
                              </div>

                              <div
                                className="
                                  col-lg-6
                                  form-group
                                  ml-2
                                "
                                style={{
                                  float: "left",
                                  padding: "0px 9px 0px 0px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "3px",
                                  }}
                                >
                                  <select
                                    name="cmbreturnHour"
                                    className="
                                      arrow
                                      form-control
                                    "
                                    value={returnHour}
                                    onChange={(e) =>
                                      setReturnHour(e.target.value)
                                    }
                                    style={{
                                      width: "50%",
                                    }}
                                  >
                                    {hours.map((hour) => (
                                      <option key={hour} value={hour}>
                                        {hour}
                                      </option>
                                    ))}
                                  </select>

                                  <select
                                    name="cmbreturnmin"
                                    className="
                                      arrow
                                      form-control
                                    "
                                    value={returnMinute}
                                    onChange={(e) =>
                                      setReturnMinute(e.target.value)
                                    }
                                    style={{
                                      width: "50%",
                                    }}
                                  >
                                    {minutes.map((minute) => (
                                      <option key={minute} value={minute}>
                                        {minute}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* CAR TYPE + DRIVER AGE */}

                          <div
                            className="col-md-12"
                            style={{
                              padding: 0,
                              float: "left",
                            }}
                          >
                            <div
                              className="
                                form-group
                                col-md-6
                              "
                              style={{
                                float: "left",
                                padding: "0px 9px 0px 0px",
                              }}
                            ></div>

                            <div
                              className="
                                form-group
                                col-md-6
                              "
                              style={{
                                float: "left",
                                padding: "0px 9px 0px 0px",
                              }}
                            ></div>
                          </div>

                          {/* BUTTONS */}

                          <div
                            className="col-md-12"
                            style={{
                              padding: 0,
                              float: "left",
                            }}
                          >
                            <div
                              className="
                                form-group
                                col-md-6
                              "
                              style={{
                                float: "left",
                                padding: "0px 9px 0px 0px",
                              }}
                            >
                              <input
                                type="submit"
                                disabled={bookingLoading || loadingLocations}
                                value={
                                  bookingLoading
                                    ? "Loading..."
                                    : bookingengine.bookingengine9 || "Continue"
                                }
                                className="
                                  btn
                                  btn-secondary1
                                "
                                style={{
                                  padding: "4px 0px",
                                }}
                              />
                            </div>

                            <div
                              className="col-md-4"
                              style={{
                                float: "right",
                                padding: "0px 5px 0px 0px",
                              }}
                            >
                              {/* code-1416 */}
                              <button
                                type="button"
                                className="btn btn-secondary2 py-3 px-4"
                                onClick={() =>
                                  setShowRegularClientLogin((prev) => !prev)
                                }
                              >
                                {bookingengine.bookingengine24 ||
                                  "Regular client Login"}
                              </button>
                            </div>
                            {/* code-1416 */}
                            {showRegularClientLogin && (
                              <div className="booking-client-row">
                                {/* CLIENT ID */}
                                <div className="booking-client-half">
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      name="clientId"
                                      value={clientId}
                                      onChange={(e) => {
                                        setClientId(e.target.value);
                                      }}
                                      className="frmtxtbox1"
                                      maxLength="30"
                                      placeholder={`${t("bookingengine.bookingengine16", "Client Id.")} :`}
                                    />

                                    <label>
                                      <span className="required-star">*</span>
                                      {t("othersnewstatics.othersnewstatic48", "When am I entitled to be a regular client")}?
                                     
                                    </label>
                                  </div>
                                </div>

                                {/* EMAIL */}
                                <div className="booking-client-half">
                                  <div className="form-group">
                                    <input
                                      type="email"
                                      name="clientEmail"
                                      value={clientEmail}
                                      onChange={(e) => {
                                        setClientEmail(e.target.value);
                                      }}
                                      className="frmtxtbox1"
                                      maxLength="100"
                                      placeholder={`${t("bookingengine.bookingengine17", "Email Id.")} :`}
                                    />

                                    <label>
                                      <span className="required-star">*</span>
                                      

                                      {t("othersnewstatics.othersnewstatic47", "I forgot my regular client ID")}?

                                    </label>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  <div className="clearfix"></div>
      {/* =====================================================
          THREE FEATURE BADGES
      ====================================================== */}

      <section className="ftco-section ftco-about">
        <div className="container">
          <div
            className="
              col-xs-12
              col-sm-12
              col-md-4
              col-lg-4
            "
            style={{
              float: "left",
            }}
          >
            <div className="badge1 locationBadge">
            <b>{t("othersnewstatics.othersnewstatic1", "Pick up & Drop off at Major Locations")}</b>
              <span>
               {t("othersnewstatics.othersnewstatic68", 
                "We are based in Heraklion Airport and Chania Airport. You can collect and return your hired vehicle straight at any Crete's Airport.")}
              </span>
            </div>
          </div>

          <div
            className="
              col-xs-12
              col-sm-12
              col-md-4
              col-lg-4
            "
            style={{
              float: "left",
            }}
          >
            <div className="badge1 insurBadge">
              <b>{t("othersnewstatics.othersnewstatic2", "Wide Range of Well-Maintained Cars")}</b>

              <span>
              {t("othersnewstatics.othersnewstatic69", 
               "We are based in Heraklion Airport and Chania Airport. You can collect and return your hired vehicle straight at any Crete's Airport.")}
              
              </span>
            </div>
          </div>

          <div
            className="
              col-xs-12
              col-sm-12
              col-md-4
              col-lg-4
            "
            style={{
              float: "left",
            }}
          >
            <div className="badge1 bookNowBadge">
              <b>
           
                {t("othersnewstatics.othersnewstatic3", "Affordable Cost With No Hidden Charges")}
                </b>

              <span>
              {t("othersnewstatics.othersnewstatic69", 
               "We are based in Heraklion Airport and Chania Airport. You can collect and return your hired vehicle straight at any Crete's Airport.")}
              
              </span>
            </div>
          </div>
        </div>

        <div className="clearfix"></div>
      </section>

      {/* =====================================================
          CAR RENTAL DEALS
      ====================================================== */}

      <section
        className="
          ftco-section
          bg-light
        "
      >
        <div className="container">
          <div
            className="
              row
              justify-content-center
            "
          >
            <div
              className="
                col-md-12
                heading-section
                text-center
              "
            >
              <h2 className="mb-2">
                {t("othersnewstatics.othersnewstatic4", "Cheap Crete Car Rental Deals")}
                </h2>
            </div>
          </div>

          {/* LOADING */}

          {loadingCars && (
            <div className="text-center">
              <p>Loading cars...</p>
            </div>
          )}

          {/* EMPTY */}

          {!loadingCars && cars.length === 0 && (
            <div className="text-center">
              <p>No cars available.</p>
            </div>
          )}

          {/* CARS */}

          {!loadingCars && cars.length > 0 && (
            <div
              className="cars-carousel-viewport"
              style={{
                overflow: "hidden",
                width: "100%",
              }}
            >
              <div
                className="cars-carousel-track"
                style={{
                  display: "flex",
                  flexWrap: "nowrap",
                  transition: "transform 0.6s ease-in-out",

                  transform: `translateX(-${
                    carouselIndex * (100 / CARDS_VISIBLE)
                  }%)`,
                }}
              >
                {cars.map((car, index) => {
                  const carImage = getCarImage(car.image);

                  const carName =
                    car.name || car.car_name || car.model_name || "Car";

                  const carCategory =
                    car.category || car.car_category || car.type || "";

                  const carPrice =
                    car.pricePerDay ?? car.price_perday ?? car.price ?? 0;

                  const carId =
                    car.carmodel_id ||
                    car.car_id ||
                    car.vehicle_id ||
                    car.id ||
                    index;

                  return (
                    <div
                      className="mb-4"
                      key={carId}
                      style={{
                        flex: `0 0 ${100 / CARDS_VISIBLE}%`,

                        maxWidth: `${100 / CARDS_VISIBLE}%`,

                        padding: "0 10px",

                        boxSizing: "border-box",
                      }}
                    >
                      <div
                        className="
                              car-wrap
                              rounded
                            "
                        style={{
                          background: "#fff",

                          overflow: "hidden",

                          height: "100%",
                        }}
                      >
                        {/* IMAGE */}

                        <div
                          className="
                                car-image-container
                              "
                          style={{
                            width: "100%",

                            height: "200px",

                            backgroundColor: "#fff",

                            display: "flex",

                            alignItems: "center",

                            justifyContent: "center",

                            overflow: "hidden",

                            boxShadow: "0 10px 25px rgba(0,0,0,.08)",
                          }}
                        >
                          <div
                            className="
                                  image-fallback
                                "
                            style={{
                              width: "100%",

                              height: "100%",

                              display: carImage ? "none" : "flex",

                              alignItems: "center",

                              justifyContent: "center",

                              color: "#999",

                              fontSize: "14px",

                              position: "absolute",

                              top: 0,

                              left: 0,
                            }}
                          >
                            No Image
                          </div>

                          {carImage && (
                            <img
                              src={carImage}
                              alt={carName}
                              loading="lazy"
                              style={{
                                width: "100%",

                                height: "220px",

                                objectFit: "contain",

                                objectPosition: "center",

                                display: "block",

                                position: "relative",

                                zIndex: 2,
                              }}
                              onError={(e) => handleImageError(e, carImage)}
                            />
                          )}
                        </div>

                        {/* CAR DETAILS */}

                        <div
                          className="text"
                          style={{
                            padding: "12px ",
                          }}
                        >
                          <h2 className="col-md-12 mb-0">
                            <a
                              href="#booking-form"
                              onClick={(e) => {
                                e.preventDefault();

                                handleDetails(car);
                              }}
                              style={{
                                textDecoration: "none",
                              }}
                            >
                              {carName}
                            </a>
                          </h2>

                          <div
                            className="
                                  d-flex
                                  mb-3
                                "
                          >
                            {/* <span className="cat">
                                  {
                                    carCategory
                                  }
                                </span> */}

                            <p
                              className="
                                    col-md-12 eggPriceprice
                                    ml-auto"
                              style={{
                                margin: "0",
                                padding: "0",
                              }}
                            >
                              <span className="eggPrice">€{carPrice}</span>

                              <span> / {tr("carparams", 0, "Per day")}</span>
                            </p>
                          </div>

                          <p
                            className="
                                  d-flex
                                  mb-0
                                  d-block
                                "
                          >
                            {/* BOOK NOW */}

                            <button
                              type="button"
                              className="
                                   btn btn-primary py-2 mr-1
                                  "
                              style={{ width: "50%" }}
                              onClick={() => handleBookNow(car)}
                            >
                              {t("othersnewstatics.othersnewstatic5", "BOOK THIS")}
                            </button>

                            {/* DETAILS */}

                            <button
                              type="button"
                              className="
                                    btn btn-secondary py-2 ml-1"
                              style={{ width: "50%" }}
                              onClick={() => handleDetails(car)}
                            >
                             {tr("carparams", 2, "Details")}
                            </button>
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* =====================================================
          WELCOME SECTION - PAGE 12
      ====================================================== */}

      <section
        className="
          about
          ftco-section
          ftco-about
        "
        style={{
          padding: 0,
        }}
      >
        <div className="container">
          <div className="row no-gutters">
            <div className="col-md-12" align="center">
              <div
                className="
                  heading-section
                  heading-section-white
                "
              >
                {/* <p
                  style={{
                    textAlign: "center",

                    position: "relative",

                    top: "26px",

                    fontSize: "20px",
                  }}
                >
                  Welcome to
                </p> */}

                <h2
                  className="aboutp"
                  style={{
                    textAlign: "center",
                  }}
                >
                  {loadingHomeContent
                    ? "Loading..."
                    : homeContent.cont_title ||
                      "Our Crete Holidays car reservation"}
                </h2>
              </div>
            </div>

            <div className="col-md-6 wrap-about1" align="center">
              <img
                src={creteImage}
                style={{
                  width: "100%",
                }}
                alt="Crete"
              />
            </div>

            <div className="col-md-6" align="center">
              <div
                className="
                  col-md-12
                  wrap-about
                "
                style={{
                  padding: "0px 15px",
                }}
              >
                <div
                  className="
                    heading-section
                    heading-section-white
                  "
                  style={{
                    textAlign: "left",
                  }}
                >
                  {loadingHomeContent ? (
                    <p>Loading content...</p>
                  ) : homeContent.cont_details ? (
                    <div
                      className="home-content-details"
                      dangerouslySetInnerHTML={{
                        __html: homeContent.cont_details,
                      }}
                    />
                  ) : (
                    <p>No content available.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* =====================================================
          WHY CHOOSE STRIP
      ====================================================== */}

      <div className="whatspp">
        <div className="container">
          <div
            className="
              col-sm-12
              booking-box
            "
            style={{
              display: "block",
              padding: 0,
            }}
          >
            <div className="col-md-12">
              <p
                className="wtext"
                style={{
                  color: "#fff",
                  fontSize: "30px",
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                 {t("othersnewstatics.othersnewstatic6", "Why Choose Car Rental From Crete Holidays")}
              </p>

              <p
                style={{
                  color: "#fff",
                  textAlign: "center",
                  fontSize: "19px",
                }}
              >
                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color: "#fbe00a",
                  }}
                ></span>
                &nbsp;
                {t("othersnewstatics.othersnewstatic7", "100% Full insurance")},
                  &nbsp;
                
                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color: "#fbe00a",
                  }}
                ></span>
                &nbsp;
                {t("othersnewstatics.othersnewstatic8", "No Extra cost on Arrival")}, 
                 &nbsp;
                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color: "#fbe00a",
                  }}
                ></span>
                &nbsp;
                {t("othersnewstatics.othersnewstatic9", "No Hidden Excess")}, 
                <br />
                &nbsp;
                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color: "#fbe00a",
                  }}
                ></span>
                &nbsp; 
                {t("othersnewstatics.othersnewstatic10", "No Credit Card Required")}, &nbsp;
                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color: "#fbe00a",
                  }}
                ></span>
                &nbsp;
                {t("othersnewstatics.othersnewstatic11", "No Cancellation Fees")}, &nbsp;
                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color: "#fbe00a",
                  }}
                ></span>
                &nbsp; {t("othersnewstatics.othersnewstatic12", "Book Easy Online Now")},&nbsp;
                <span
                  className="
                    icon
                    icon-star
                  "
                  style={{
                    color: "#fbe00a",
                  }}
                ></span>
                &nbsp;{t("othersnewstatics.othersnewstatic13", "No Prepayment Required")} 
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* =====================================================
          IMPORTANT TO KNOW
      ====================================================== */}

      <div className="">
        <section className="why-choose-us-area">
          <div className="container">
            <div className="row">
              <div className="col-md-12" align="center">
                <div
                  className="
                    heading-section
                    heading-section-white
                  "
                >
                  {/* <p
                    style={{
                      textAlign: "center",

                      position: "relative",

                      top: "26px",

                      fontSize: "20px",
                    }}
                  >
                    Also
                  </p> */}

                  <h2
                    className="aboutp"
                    style={{
                      textAlign: "center",
                    }}
                  >
                    {t("othersnewstatics.othersnewstatic70", "Important to know")}
                    
                  </h2>
                </div>
              </div>
            </div>

            <div className="row">
              {/* PAGE 9 */}

              <div
                className="col-md-6"
                style={{
                  padding: "0 10px",

                  marginBottom: "20px",
                }}
              >
                <div
                  className="
                    services
                    services-2
                    w-100
                  "
                  style={{
                    height: "100%",
                  }}
                >
                  <div
                    className="
                      pr28
                      text-1
                      text
                      w-100
                    "
                    style={{
                      height: "100%",
                    }}
                  >
                    <div
                      className="price-card"
                      style={{
                        height: "100%",
                      }}
                    >
                      <div className="content">
                        <h2>
                          {loadingWhyChoose
                            ? "Loading..."
                            : whyChooseContents.page9.cont_title ||
                              "Also important to know:"}
                        </h2>
                      </div>

                      {!loadingWhyChoose &&
                        whyChooseContents.page9.cont_details && (
                          <div
                            className="why-content-page9"
                            dangerouslySetInnerHTML={{
                              __html: cleanContentHtml(
                                whyChooseContents.page9.cont_details
                              ),
                            }}
                          />
                        )}
                    </div>
                  </div>
                </div>
              </div>

              {/* PAGE 10 + PAGE 11 */}

              <div
                className="col-md-6"
                style={{
                  padding: "0 10px",

                  marginBottom: "20px",
                }}
              >
                <div
                  className="
                    pr28
                    services
                    services-2
                    w-100
                  "
                  style={{
                    height: "100%",
                  }}
                >
                  <div
                    className="price-card1"
                    style={{
                      height: "100%",
                    }}
                  >
                    {/* PAGE 10 */}

                    <div className="content">
                      <h2>
                        {loadingWhyChoose
                          ? "Loading..."
                          : whyChooseContents.page10.cont_title ||
                            "Attention!!"}
                      </h2>
                    </div>

                    {!loadingWhyChoose &&
                      whyChooseContents.page10.cont_details && (
                        <div
                          className="why-content-page10"
                          dangerouslySetInnerHTML={{
                            __html: cleanContentHtml(
                              whyChooseContents.page10.cont_details
                            ),
                          }}
                        />
                      )}

                    <div className="clearfix"></div>

                    {/* PAGE 11 */}

                    <div className="content">
                      <h2>
                        {loadingWhyChoose
                          ? "Loading..."
                          : whyChooseContents.page11.cont_title ||
                            "Enjoy your holidays"}
                      </h2>
                    </div>

                    {!loadingWhyChoose &&
                      whyChooseContents.page11.cont_details && (
                        <div
                          className="why-content-page11"
                          dangerouslySetInnerHTML={{
                            __html: cleanContentHtml(
                              whyChooseContents.page11.cont_details
                            ),
                          }}
                        />
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* =====================================================
          CAR DETAILS MODAL
      ====================================================== */}

      <CarDetailsModal
        show={showCarDetailsModal}
        onClose={closeCarDetailsModal}
        car={selectedCarForDetails}
        loading={false}
        error=""
        getCarImage={getCarImage}
        onBook={handleBookNow}
      />
    </div>
  );
}

export default HomePage;
